import axios from 'axios';

import { toApiDateTime } from '../utils/dateUtils';

const createDesignAndEngineeringProject = async ({ name, client, status, poNumber, startDate, endDate, engineeringCompany, designCompany }) => {
  const { data: designAndEngineeringProject } = await axios.post(`${process.env.REACT_APP_API_URL}/design-and-engineering-projects`, {
    name,
    client,
    status,
    poNumber,
    startDate: toApiDateTime(startDate),
    endDate: toApiDateTime(endDate),
    engineeringCompany,
    designCompany
  });

  return { designAndEngineeringProject };
}

const updateDesignAndEngineeringProject = async ({ designAndEngineeringProjectId, updateData }) => {
  const payload = { ...updateData };

  if (payload.startDate) payload.startDate = toApiDateTime(payload.startDate);
  if (payload.endDate) payload.endDate = toApiDateTime(payload.endDate);

  const { data: designAndEngineeringProject } = await axios.put(`${process.env.REACT_APP_API_URL}/design-and-engineering-projects/${designAndEngineeringProjectId}`, payload);

  return { designAndEngineeringProject };
}

const allocateStaff = async ({ projectId, staffIds }) => {
  const { data: project } = await axios.put(`${process.env.REACT_APP_API_URL}/design-and-engineering-projects/${projectId}/allocate-staff`, {
    staffIds
  });

  return { project };
}

const importDesignAndEngineeringProjects = async () => {
  await axios.get(`${process.env.REACT_APP_API_URL}/sync/design-and-engineering-projects`);

  return { message: 'Design and engineering projects import initiated' };
}

const designAndEngineeringProjectService = {
  createDesignAndEngineeringProject,
  updateDesignAndEngineeringProject,
  allocateStaff,
  importDesignAndEngineeringProjects
};

export default designAndEngineeringProjectService;
